// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__22z45","emails":"CreateEditClinics_emails__2peaO","emailTagLabel":"CreateEditClinics_emailTagLabel__1sBgq"};